import { Component, OnInit } from '@angular/core';
@Component({
    selector: 'emm-home',
    styleUrls: ['./home.component.scss'],
    templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {

    constructor() {}

    ngOnInit(): void {}

}
